module.exports = __webpack_public_path__ + "img/postback-step-2.ru.8a5fd4d0.jpg";